import { type EffectiveSharingMode, SHARING_MODE } from '../../variable-sharing/utils/types';

export const PLATFORM_OPTIONS = [
  {
    altText: 'Share across all platforms',
    id: 'platform-share-all',
    label: 'Share across all platforms',
  },
  {
    altText: 'Separate values for each platform',
    id: 'platform-no-sharing',
    label: 'Separate values for each platform',
  },
] as const;

export const MARKETPLACE_OPTIONS = [
  {
    altText: 'Share across all selected marketplaces and languages',
    id: 'marketplace-share-all',
    label: 'Share across all selected marketplaces and languages',
  },
  {
    altText: 'Share across all languages within each marketplace',
    id: 'marketplace-share-per-marketplace',
    label: 'Share across all languages within each marketplace',
  },
  {
    altText: 'Share across all variations with the same language',
    id: 'marketplace-share-same-language',
    label: 'Share across all variations with the same language',
  },
  {
    altText: 'No sharing between marketplaces or languages',
    id: 'marketplace-no-sharing',
    label: 'No sharing between marketplaces or languages',
  },
] as const;

type PlatformOption = (typeof PLATFORM_OPTIONS)[number];
type MarketplaceOption = (typeof MARKETPLACE_OPTIONS)[number];

type PlatformCardId = PlatformOption['id'];
type MarketplaceCardId = MarketplaceOption['id'];

export type SharingCardId = PlatformCardId | MarketplaceCardId;
export type SharingCardOption = PlatformOption | MarketplaceOption;

const SHARING_MODE_SELECTIONS: Record<
  EffectiveSharingMode,
  {
    marketplaceCardId: MarketplaceCardId;
    platformCardId: PlatformCardId;
  }
> = {
  [SHARING_MODE.ALL]: {
    marketplaceCardId: 'marketplace-share-all',
    platformCardId: 'platform-share-all',
  },
  [SHARING_MODE.LANGUAGE]: {
    marketplaceCardId: 'marketplace-share-same-language',
    platformCardId: 'platform-share-all',
  },
  [SHARING_MODE.LOCALE]: {
    marketplaceCardId: 'marketplace-no-sharing',
    platformCardId: 'platform-share-all',
  },
  [SHARING_MODE.MARKETPLACE]: {
    marketplaceCardId: 'marketplace-share-per-marketplace',
    platformCardId: 'platform-share-all',
  },
  [SHARING_MODE.PLATFORM]: {
    marketplaceCardId: 'marketplace-share-all',
    platformCardId: 'platform-no-sharing',
  },
  [SHARING_MODE.PLATFORM_AND_LANGUAGE]: {
    marketplaceCardId: 'marketplace-share-same-language',
    platformCardId: 'platform-no-sharing',
  },
  [SHARING_MODE.PLATFORM_AND_MARKETPLACE]: {
    marketplaceCardId: 'marketplace-share-per-marketplace',
    platformCardId: 'platform-no-sharing',
  },
  [SHARING_MODE.NONE]: {
    marketplaceCardId: 'marketplace-no-sharing',
    platformCardId: 'platform-no-sharing',
  },
} as const;

export const getSharingModeSelections = (sharingMode: EffectiveSharingMode) => SHARING_MODE_SELECTIONS[sharingMode];
